/**
 * Synthetic chat tools that are not stored in data_vector_search_tool_*
 * but are available for prompt / workflow-button tool pickers.
 * Deep Research is a real tool_kind — create tools in Tools UI instead.
 */
export const SYNTHETIC_CHAT_TOOLS_FOR_PICKER = [
  {
    id: 'email_draft:save',
    name: 'save_email_draft',
    slug: 'save_email_draft',
    description: 'Save or update an email draft in Zagger.',
    kind: 'email_draft',
  },
  {
    id: 'email_draft:export_md',
    name: 'export_email_draft_md',
    slug: 'export_email_draft_md',
    description: 'Export a saved email draft as markdown.',
    kind: 'email_draft',
  },
  {
    id: 'email_draft:gmail',
    name: 'save_email_draft_to_gmail',
    slug: 'save_email_draft_to_gmail',
    description: 'Push a saved draft to Gmail (does not send).',
    kind: 'email_draft',
  },
  {
    id: 'locked_record:find',
    name: 'request_find_record',
    slug: 'request_find_record',
    description: 'Ask the chat UI to open Find Record.',
    kind: 'locked_record',
  },
  {
    id: 'locked_record:lock',
    name: 'lock_conversation_record',
    slug: 'lock_conversation_record',
    description: 'Lock a horizon entry to the conversation.',
    kind: 'locked_record',
  },
  {
    id: 'locked_record:unlock',
    name: 'unlock_conversation_record',
    slug: 'unlock_conversation_record',
    description: 'Unlock the conversation record.',
    kind: 'locked_record',
  },
  {
    id: 'embedding:initiate',
    name: 'initiate_embedding',
    slug: 'initiate_embedding',
    description: 'Queue Initiate Embedding for a search tool.',
    kind: 'embedding',
  },
];

export function mergeSyntheticToolsIntoPickerList(horizonTools = []) {
  const byId = new Map();
  (Array.isArray(horizonTools) ? horizonTools : []).forEach((t) => {
    const id = String(t?.id || '').trim();
    if (!id) return;
    byId.set(id, t);
  });
  SYNTHETIC_CHAT_TOOLS_FOR_PICKER.forEach((t) => {
    if (!byId.has(t.id)) byId.set(t.id, { ...t });
  });
  return Array.from(byId.values()).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
}
